import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

export default class FieldGoalBlockedRecovery extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            play.historyContains(FootballState.FieldGoal) &&
            (fragment.associatedState === FootballState.KickRecovered ||
                fragment.associatedState === FootballState.KickNotRecovered)
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { recoveredBy, recoveredAt } = fragment;
        ruleContext.setAwardFirstDown(true);
        gameContext.setCurrentPlayerInPossession(recoveredBy);
        gameContext.setPossessionForTeamId(recoveredBy.teamId);
        gameContext.setFieldPosition(recoveredAt);
    }
}
